import React ,{ useEffect } from "react";
import { componentDidMount } from '../helpers/AuthContext';

function Error404NotFound() {
    useEffect(()=>{
        componentDidMount("¡Ups! No hemos encontrado lo que buscas");
    },[]);

    return (
        <div>
            <div className="notFound">
                <h2>404 Not Found</h2>
                <p>¡Ups! No hemos encontrado lo que buscas</p>
            </div>
        </div>
    )
}

export default Error404NotFound
